<template>
  <div id="dashboard" class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="row push">
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ stopOrderArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#82b54b"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#82b54b"
                data-highlight-line-color="#82b54b"
                data-tooltip-suffix="笔"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.stopOrder || 0}}</p>
              <p class="text-muted mb-0 font-size-75">停车订单</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ chargeOrderArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#e04f1a"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#e04f1a"
                data-highlight-line-color="#e04f1a"
                data-tooltip-suffix="笔"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.chargeOrder || 0}}</p>
              <p class="text-muted mb-0 font-size-75">充电订单</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ packageOrderArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#3c90df"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#3c90df"
                data-highlight-line-color="#3c90df"
                data-tooltip-suffix="笔"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.packageOrder || 0}}</p>
              <p class="text-muted mb-0 font-size-75">时长包订单</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ totalOrderArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#343a40"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#343a40"
                data-highlight-line-color="#343a40"
                data-tooltip-suffix="笔"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{orderNum.totalOrder || 0}}</p>
              <p class="text-muted mb-0 font-size-75">总订单数(笔)</p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-12" style="margin-bottom: 10px;">
      <div class="row mb-2 mt-4" style="margin-right: -64px;">
        <div class="col-6 row">
          <h2 class="h3 font-w400 mb-0 line-height">全部订单</h2>
        </div>
        <div class="col-6 text-right mr-0">
          <screenTime :isToday="'0'" :isBlack="true" @changePage="changePage"></screenTime>
        </div>
      </div>
    </div>
    <div id="dashboard">
      <div class="block block-rounded block-bordered">
        <div class="block-header block-header-default" style="padding: 0;">
          <ul
            class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
            data-toggle="tabs"
            role="tablist"
          >
            <li class="nav-item" v-for="(item,index) in orderTypeList" :key="index">
              <a
                class="nav-link"
                :class="['btabs-animated-fade-'+item.ORDER_TYPE ,
                [orderTypeList.length>1&&(item.ORDER_TYPE==orderType||index==0)?'active':''],
                [orderTypeList.length==1?' oneTable':'']]"
                href="javascript:void(0)"
                @click="showTab('btabs-animated-fade-'+item.ORDER_TYPE,item.ORDER_TYPE)"
              >{{item.ORDER_NAME}}</a>
            </li>
          </ul>
          <div style="margin-right: 1.25rem">
            <button
              type="button"
              class="btn-block-option"
              data-toggle="block-option"
              data-action="fullscreen_toggle"
            >
              <i class="si si-size-fullscreen"></i>
            </button>
          </div>
        </div>
        <div class="block-content tab-content overflow-hidden">
          <div
            class="tab-pane tab-pane-tab fade"
            id="btabs-animated-fade-1"
            role="tabpanel"
            v-show="isChargePageTabs"
            :class="{' show active':isChargePageTabs }"
          >
            <chargeOrder ref="chargeOrder"></chargeOrder>
          </div>
          <div
            class="tab-pane tab-pane-tab fade"
            id="btabs-animated-fade-2"
            role="tabpanel"
            v-show="isHistoryPageTabs"
            :class="{' show active':!isChargePageTabs&&  isHistoryPageTabs }"
          >
            <chargeHistory ref="chargeHistory"></chargeHistory>
          </div>
          <div
            class="tab-pane tab-pane-tab fade"
            id="btabs-animated-fade-3"
            role="tabpanel"
            v-show="isStopPageTabs"
            :class="{' show active':!isChargePageTabs &&!isHistoryPageTabs &&isStopPageTabs  }"
          >
            <stopOrder ref="stopOrder"></stopOrder>
          </div>
          <div
            class="tab-pane tab-pane-tab fade"
            id="btabs-animated-fade-4"
            role="tabpanel"
            v-show="isPackagePageTabs"
            :class="{' show active':!isChargePageTabs &&!isHistoryPageTabs &&!isStopPageTabs&& isPackagePageTabs}"
          >
            <carportPackage ref="carportPackage"></carportPackage>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";

import chargeOrder from "../../management/user/carportChagreingOrder";
import chargeHistory from "../../management/user/carportHistory";
import stopOrder from "../../management/user/carportStopOrder.vue";
import carportPackage from "../carPortList/carportPackageList/carportPackage";

export default {
  name: "index",
  data() {
    return {
      orderNum: {},
      orderType: 1,
      oldOrderTypeList: [
        {
          ORDER_TYPE: "1",
          ORDER_NAME: "在线充电订单",
          SHOW_TAB: Util.isPageTabsPerm("onlineCarportPackageList")
        },
        {
          ORDER_TYPE: "2",
          ORDER_NAME: "历史充电订单",
          SHOW_TAB: Util.isPageTabsPerm("carportChargeOrder")
        },
        {
          ORDER_TYPE: "3",
          ORDER_NAME: "停车订单",
          SHOW_TAB: Util.isPageTabsPerm("carportStopOrder")
        },
        {
          ORDER_TYPE: "4",
          ORDER_NAME: "停车包订单",
          SHOW_TAB: Util.isPageTabsPerm("carportPackageList")
        }
      ],
      stopOrderArr: [],
      chargeOrderArr: [],
      packageOrderArr: [],
      totalOrderArr: [],
      orderTypeList: [],
      isChargePageTabs: Util.isPageTabsPerm("onlineCarportPackageList"),
      isHistoryPageTabs: Util.isPageTabsPerm("carportChargeOrder"),
      isStopPageTabs: Util.isPageTabsPerm("carportStopOrder"),
      isPackagePageTabs: Util.isPageTabsPerm("carportPackageList")
    };
  },
  components: {
    screenTime,
    pageSize,
    chargeOrder,
    chargeHistory,
    stopOrder,
    carportPackage
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    },
    fullscreenLoading() {
      return this.$store.state.fullscreenLoading;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getOrderNum();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    this.oldOrderTypeList.find(item => {
      if (item.SHOW_TAB) {
        this.orderTypeList.push(item);
      }
    });
    this.getOrderNum();
  },
  methods: {
    showTab(el, type) {
      this.orderType = type;
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      if (type == 1) {
        this.$refs.chargeOrder.getList();
      } else if (type == 2) {
        this.$refs.chargeHistory.getList();
      } else if (type == 3) {
        this.$refs.stopOrder.getList();
      } else if (type == 4) {
        this.$refs.carportPackage.getList();
      }
    },
    getOrderNum() {
      this.$http
        .get(
          `${Util.searchURL}/Carport/GetOrderInfo/${this.duration.startDate}/${this.duration.endDate}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(res => {
          if (res.data.code === 200) {
            this.orderNum = res.data.data;
            this.stopOrderArr = [];
            this.chargeOrderArr = [];
            this.packageOrderArr = [];
            this.totalOrderArr = [];
            if (res.data.data) {
              let log = res.data.data.log;
              log.find(d => {
                this.stopOrderArr.push(Number(d.stopOrderNum));
                this.chargeOrderArr.push(Number(d.orderNum));
                this.packageOrderArr.push(Number(d.pacageOrderNum));
                this.totalOrderArr.push(Number(d.totalOrderNum));
              });
            }
            $(function() {
              Dashmix.helpers([
                "easy-pie-chart",
                "sparkline",
                "datepicker",
                "flatpickr"
              ]);
            });
            this.$store.commit("setParam", {
              fullscreenLoading: false
            });
          }
        });
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    changePage(val) {
      this.page = val;
    }
  }
};
</script>